<div class="relative min-h-screen space-y-8 rounded-xl bg-white p-6 shadow-sm dark:bg-surface-0">
    <!-- ambient -->
    <div class="pointer-events-none absolute -top-24 left-1/2 h-72 w-[min(100%,42rem)] -translate-x-1/2 rounded-full bg-gradient-to-br from-[#AD46FF]/10 via-fuchsia-500/5 to-cyan-400/5 blur-3xl dark:from-purple-500/5 dark:via-violet-600/5 dark:to-cyan-500/5"
        aria-hidden="true"></div>
    <div class="pointer-events-none absolute top-32 right-0 h-48 w-48 rounded-full bg-gradient-to-tl from-emerald-400/5 to-transparent blur-2xl dark:from-emerald-500/5"
        aria-hidden="true"></div>

    <div class="relative flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div class="flex flex-col gap-1.5">
            <!-- <div
                class="inline-flex w-fit items-center gap-2 rounded-full border border-[#E8E8F4] bg-white/80 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-[#6B6B8F] shadow-sm backdrop-blur-sm dark:border-line dark:bg-surface-1/80 dark:text-ink-muted">
                <span class="h-1.5 w-1.5 rounded-full bg-gradient-to-r from-[#AD46FF] to-cyan-400"></span>
                Chatbot Workspace
            </div> -->
            <h1 class="text-3xl font-bold tracking-tight text-[#141437] dark:text-white">
                Chatbot Workspace
            </h1>
            <p class="max-w-xl text-sm leading-relaxed text-[#5C5C7A] dark:text-ink-subtle">
                Build, manage, and scale intelligent agent workflows from a single place.
            </p>
        </div>

        <app-button variant="primary" [iconName]="'plus'"
            className="flex shrink-0 items-center justify-center gap-2 shadow-lg shadow-purple-500/25"
            (buttonClick)="navigateToCreateBot()">
            Create Chatbot
        </app-button>
    </div>

    @if (chatbotsCount() === 0) {
    <div
        class="card-bg relative overflow-hidden rounded-2xl border border-[rgba(234,234,234,1)] p-10 shadow-[0_24px_80px_-24px_rgba(80,60,120,0.35)] dark:border-line dark:shadow-[0_24px_80px_-24px_rgba(0,0,0,0.55)]">
        <div
            class="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-gradient-to-br from-[#AD46FF]/20 to-cyan-400/10 blur-2xl">
        </div>
        <div class="relative flex flex-col items-center justify-center text-center">
            <div
                class="mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-[#AD46FF]/15 to-cyan-500/10 ring-1 ring-[#AD46FF]/25 dark:from-purple-500/20 dark:to-cyan-500/5 dark:ring-purple-500/30">
                <app-tooltip content="Chatbot" position="top" [className]="'whitespace-nowrap !px-3 !py-1.5 !text-xs'">
                    <app-icon-v2 name="bot" [size]="36" class="text-[#AD46FF] dark:text-purple-400" />
                </app-tooltip>
            </div>
            <h2 class="text-xl font-semibold text-[#38385B] dark:text-ink-soft">
                No chatbots yet
            </h2>
            <p class="mt-2 max-w-md text-sm leading-relaxed text-[#6B6B8F] dark:text-ink-subtle">
                Start your first AI assistant to automate conversations, route workflows, and keep responses on-brand.
            </p>
            <app-button variant="primary" [iconName]="'plus'" className="mt-8 flex items-center justify-center gap-2"
                (buttonClick)="navigateToCreateBot()">
                Create your first bot
            </app-button>
        </div>
    </div>
    } @else {
    <div class="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="text-lg font-semibold text-gray-700 dark:text-gray-300">
            Total Chatbots: {{ chatbotsCount() || 0}}
        </div>
    </div>

    <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
        @for (bot of chatbots(); track bot.pid) {
        <div class="relative w-full self-start">
            <div
                class="group/card flex flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white/80 shadow-sm backdrop-blur-md transition-all duration-300 hover:border-purple-200 hover:shadow-md dark:border-white/5 dark:bg-surface-0/50 dark:hover:border-line-strong">
                <!-- Card Header -->
                <div class="flex items-center justify-between p-5 pb-6">
                    <div class="flex items-center gap-4">
                        <div
                            class="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-purple-50 p-2 text-purple-600 transition-all duration-300 group-hover/card:bg-purple-100 group-hover/card:ring-4 group-hover/card:ring-purple-200/50 group-hover/card:shadow-[0_0_30px_rgba(168,85,247,0.45)] bg-[#141437]/50 dark:bg-surface-0 dark:text-purple-400 dark:group-hover/card:bg-surface-0 dark:group-hover/card:ring-surface-0 dark:group-hover/card:shadow-[0_0_20px_rgba(168,85,247,0.2)]">
                            <svg viewBox="0 0 100 100" class="h-10 w-10" xmlns="http://www.w3.org/2000/svg">
                                <g class="bot-head-animated">
                                    <path d="M15 45 Q 15 42 18 42 L 22 42 L 22 68 L 18 68 Q 15 68 15 65 Z" fill="currentColor" />
                                    <path d="M85 45 Q 85 42 82 42 L 78 42 L 78 68 L 82 68 Q 85 68 85 65 Z" fill="currentColor" />
                                    <rect x="22" y="30" width="56" height="45" rx="12" fill="transparent" stroke="currentColor" stroke-width="6" />
                                    <rect x="47" y="15" width="6" height="15" fill="currentColor" />
                                    <circle cx="50" cy="10" r="6" fill="currentColor" class="bot-antenna-dot-animated" />
                                    <rect x="34" y="48" width="10" height="4" rx="2" fill="currentColor" class="bot-eye-animated" style="transform-origin: 39px 50px" />
                                    <rect x="56" y="48" width="10" height="4" rx="2" fill="currentColor" class="bot-eye-animated" style="transform-origin: 61px 50px" />
                                    <rect x="43" y="60" width="14" height="4" rx="2" fill="currentColor" />
                                </g>
                            </svg>
                        </div>
                        <div class="min-w-0">
                            <h3
                                class="line-clamp-2 text-sm font-bold text-[#141437] dark:text-white">
                                {{ bot.name }}
                            </h3>
                        </div>
                    </div>
                    <div class="flex items-center gap-2">
                        <app-tooltip content="Open agent step" position="bottom"
                            [className]="'whitespace-nowrap !text-xs'">
                            <button type="button"
                                class="flex h-8 w-8 items-center justify-center rounded-xl bg-transparent text-gray-400 transition-all duration-200 hover:bg-purple-50 hover:text-purple-600 dark:text-gray-500 dark:hover:bg-white/10 dark:hover:text-white cursor-pointer"
                                (click)="navigateToBot(bot.pid, 'agent')">
                                <app-icon-v2 name="external-link" [size]="18" />
                            </button>
                        </app-tooltip>
                        @if (!bot.isDeployed) {
                        <app-tooltip content="Delete" position="bottom"
                            [className]="'whitespace-nowrap !text-xs'">
                            <button type="button"
                                class="flex h-8 w-8 items-center justify-center rounded-xl bg-transparent text-gray-400 transition-all duration-200 hover:bg-red-50 hover:text-red-500 dark:text-gray-500 dark:hover:bg-red-900/20 dark:hover:text-red-400 cursor-pointer"
                                (click)="confirmDeleteChatbot(bot)">
                                <app-icon-v2 name="trash" [size]="18" />
                            </button>
                        </app-tooltip>
                        }
                    </div>
                </div>

                <!-- Divider -->
                <div class="mx-5 border-t border-gray-100 dark:border-white/5"></div>

                <!-- Card Footer (Metadata) -->
                <div class="grid grid-cols-3 divide-x divide-gray-100 bg-gray-50/30 dark:divide-white/5 dark:bg-surface-0/50">
                    <!-- DEV Section -->
                    <div class="flex flex-col gap-1.5 p-3 pl-5">
                        <div class="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500">
                            <app-icon-v2 name="user-round" [size]="12" />
                            DEV
                        </div>
                        <app-tooltip [content]="bot.userName" position="top" [block]="true" [className]="'min-w-0 w-full whitespace-nowrap !text-[11px]'">
                            <p class="truncate text-xs font-bold text-gray-700 dark:text-indigo-100/90">
                                {{ bot.userName }}
                            </p>
                        </app-tooltip>
                    </div>
                    <!-- CREATED Section -->
                    <div class="flex flex-col gap-1.5 p-3">
                        <div class="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500">
                            <app-icon-v2 name="calendar" [size]="12" />
                            CREATED
                        </div>
                        <p class="truncate text-xs font-bold text-gray-700 dark:text-indigo-100/90">
                            {{ bot.createdAt | date : 'mediumDate' }}
                        </p>
                    </div>
                    <!-- UPDATED Section -->
                    <div class="flex flex-col gap-1.5 p-3">
                        <div class="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500">
                            <app-icon-v2 name="clock" [size]="12" />
                            UPDATED
                        </div>
                        <p class="truncate text-xs font-bold text-gray-700 dark:text-indigo-100/90">
                            {{ bot.updatedAt | date : 'mediumDate' }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>
    }

    <app-chat-workspace-interface
        [open]="chatPanelOpen()"
        [bot]="chatPanelBot()"
        (closed)="closeChatPanel()"
    />
</div>